// extracted by mini-css-extract-plugin
export default {"mainBox":"Subscribers_mainBox__Mgz2i","main":"Subscribers_main__LFX2B","Channelicon":"Subscribers_Channelicon__zSmty","ChannelName":"Subscribers_ChannelName__X0mcC"};